import { createFileRoute } from "@tanstack/react-router";
import JainPanchangPage from "@project/user/pages/community/jain-panchang";

export const Route = createFileRoute("/_user/_community/jain-panchang")({
  head: () => ({
    meta: [
      { title: "Jain Panchang — Jivandhara Old Age Home" },
      {
        name: "description",
        content:
          "Explore the Jain lunar calendar with tithis, festivals, vows and spiritual guidance from Jivandhara.",
      },
    ],
  }),
  component: JainPanchangPage,
});
